export const monitoringRoutes = [
  {
    path: 'monitoring',
    children: [
      {
        path: 'inbox',
        loadChildren: () => import('@rma/dashboard/monitoring/inbox'),
      },
      {
        path: 'leaderboards',
        loadChildren: () => import('@rma/dashboard/monitoring/leaderboards'),
      },
      {
        path: 'online-performance',
        loadChildren: () => import('@rma/dashboard/reporting/roi-insights'),
      },
    ],
  },
];
